export const PENDING = 0;
export const COMPLETE = 1;
export const DONE = 'DONE';
export const SCHEDULED = 'SCHEDULED';
export const CANCELED = 'CANCELED';
export const MISSED = 'MISSED';
export const SKIPPED = 'SKIPPED';
export const PARTIAL = 'PARTIAL';
